import { Component, input, output } from '@angular/core';

@Component({
    standalone: false,
  selector: 'wl-save-cancel-actions',
  templateUrl: './save-cancel-actions.component.html'
})
export class SaveCancelActionsComponent {
  isSaving = input<boolean>(false);
  isSaveDisabled = input<boolean>(false);
  error = input<string | null>(null);
  showSave = input<boolean>(true);
  saveLabel = input<string>('common.save');

  onSave = output<void>();
  onCancel = output<void>();

  save(): void {
    this.onSave.emit();
  }

  cancel(): void {
    this.onCancel.emit();
  }
}